export default __webpack_public_path__ + "static/media/sgbWheel_banner.b128c4cc.png";